import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Profile } from '../models/profile.model';
import { PlanType } from '../models/plantype.model';
import { Product } from '../models/productStore.model';

@Injectable()
export class ProfileService {
    constructor(private http: HttpClient) {
    }

    public hasFullPlatform(profile: Profile) {
        debugger
        if (profile.platformInfo != null) {
            if (profile.platformInfo.seoName == 'nuvemshop-flower')
                return true
            if (profile.platformInfo.seoName == 'tray-pollinator')
                return true
            if (profile.platformInfo.seoName == 'loja-integrada-flower')
                return true
            if (profile.platformInfo.seoName == 'vtex-flower')
                return true
            if (profile.platformInfo.seoName == 'xtech-flower')
                return true
        }
        return false
    }

    GetProfilePlanInfo(seoUrl: any = null): any {
        if (seoUrl != null) {
            return this.http.get(Configuration.apiUrl + 'Api/Profile/GetProfilePlanInfo?seoName=' + seoUrl + '&polenTest=true')
        }
        else {
            return this.http.get(Configuration.apiUrl + 'Api/Profile/GetProfilePlanInfo')
        }

    }

    getCurrentUserInfo(seoUrl: any = null): any {
        if (seoUrl != null) {
            return this.http.get(Configuration.apiUrl + 'Api/Profile/GetProfile?seoName=' + seoUrl + '&polenTest=true')
        }
        else {
            return this.http.get(Configuration.apiUrl + 'Api/Profile/GetProfile')
        }

    }

    getBilling(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Billing/GetBilling')
    }

    getGetCategoryList(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Profile/GetListCategory')
    }

    getExternalLoginProfile(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Account/GetExternalLoginProfile')
    }

    getBillingUserInfo(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Profile/GetProfile?billingDetail=true')
    }

    getReferralList(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Profile/GetReferralList')
    }

    getApiAccess(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Profile/GetApiAccess')
    }

    updateApiStatus(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Profile/UpdateApiStatus')
    }

    updateApiAccess(apiAccess): any {
        console.log(apiAccess);
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/Profile/UpdateApiAccess', JSON.stringify(apiAccess), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    clearStoreCache(storeName): any {
        return this.http.get(Configuration.apiUrl + 'Api/Profile/ClearStoreCache?storeName=' + storeName)
    }
    
    clearStoreApiCache(storeName): any {
        return this.http.get(Configuration.storeApiUrl + 'Api/Profile/ClearStoreCache?storeName=' + storeName)
    }

    updateProfile(user): any {
        //console.log(JSON.stringify(user));
        return this.http.post(Configuration.apiUrl + 'Api/Profile/UpdateProfile', JSON.stringify(user), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updateReferralCode(user): any {
        return this.http.post(Configuration.apiUrl + 'Api/Profile/UpdateReferralCode', JSON.stringify(user), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    getUsers(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Account/List')
    }

    saveUser(user): any {
        return this.http.post(Configuration.apiUrl + 'Api/Account/Save', JSON.stringify(user), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    deleteUser(email): any {
        return this.http.get(Configuration.apiUrl + 'Api/Account/Delete?email=' + email)
    }

    //start billing methods
    getPlanPeriodLabel(profile: Profile, plan: PlanType) {
        var planPeriodLabel = '';
        if (profile != null) {
            if (profile.planPeriod > 0) {
                if (profile.planPeriod == 1)
                    planPeriodLabel = "mensal"

                if (profile.planPeriod == 3)
                    planPeriodLabel = "trimestral"

                if (profile.planPeriod == 6)
                    planPeriodLabel = "semestral"

                if (profile.planPeriod == 12)
                    planPeriodLabel = "anual"
            }
        }

        if (plan != null) {
            if (plan.period > 0) {
                if (plan.period == 1) {
                    planPeriodLabel = "mensal"
                }

                if (plan.period == 3) {
                    planPeriodLabel = "trimestral"
                }


                if (plan.period == 6) {
                    planPeriodLabel = "semestral"
                }


                if (plan.period == 12) {
                    planPeriodLabel = "anual"
                }
            }
        }
        return planPeriodLabel;
    }

    getPlanPriceSplitted(profile: Profile, plan: PlanType) {
        var priceSplited = 0;
        if (profile != null) {
            if (profile.planPeriod > 0) {
                if (profile.planPeriod == 1)
                    priceSplited = profile.planPeriod

                if (profile.planPeriod == 3)
                    priceSplited = profile.planPeriod / 3

                if (profile.planPeriod == 6)
                    priceSplited = profile.planPeriod / 6

                debugger
                //soh estamos permitindo parcelamento em até 6x
                if (profile.planPeriod == 12)
                    priceSplited = profile.planPeriod / 12
            }
        }

        if (plan != null) {
            if (plan.period > 0) {
                if (plan.period == 1) {
                    priceSplited = plan.price
                }

                if (plan.period == 3) {
                    priceSplited = plan.price / 3
                }

                if (plan.period == 6) {
                    priceSplited = plan.price / 6
                }


                if (plan.period == 12) {
                    //soh estamos permitindo parcelamento em até 6x
                    priceSplited = plan.price / 12
                }
            }
        }
        return priceSplited;
    }

    getInvoices(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Billing/GetInvoices')
    }

    getPageInvoice(id): any {
        // console.log(Configuration.apiUrl + 'Api/Billing/getPageInvoice?id=' + id);
        return this.http.get(Configuration.apiUrl + 'Api/Billing/getPageInvoice?id=' + id)
    }

    getBillingData(seoUrl, identifier, billingType, zipcode): any {
        //console.log(Configuration.apiUrl + 'api/billing/GetBillingData?seoUrl=' + seoUrl + '&identifier=' + identifier + '&billingType=' + billingType + '&zipcode=' + zipcode);
        return this.http.get(Configuration.apiUrl + 'api/billing/GetBillingData?seoUrl=' + seoUrl + '&identifier=' + identifier + '&billingType=' + billingType + '&zipcode=' + zipcode)
    }

    getDonationsFromInvoices(statementId): any {
        //console.log(Configuration.apiUrl + 'Api/Billing/GetDonationsFromInvoices?statementId=' + statementId);
        return this.http.get(Configuration.apiUrl + 'Api/Billing/GetDonationsFromInvoices?statementId=' + statementId)
    }

    getChangePlan(id): any {
        return this.http.get(Configuration.apiUrl + 'Api/Billing/ChangePlan?planTypeId=' + id)
    }

    getPlan(id, hasDetail): any {
        return this.http.get(Configuration.apiUrl + 'Api/Billing/GetPlan?planTypeId=' + id + '&hasDetail=' + hasDetail)
    }

    //altera apenas o numero de parcelas no cartao de credito
    changeInstallment(installment): any {
        return this.http.get(Configuration.apiUrl + 'Api/Billing/ChangeInstallment?installment=' + installment)
    }

    saveBillingInfo(profile): any {
        console.log(JSON.stringify(profile))
        return this.http.post(Configuration.apiUrl + 'Api/billing/SaveBillingInfo', JSON.stringify(profile), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    changePaymentMethodDefault(id, isDefault): any {
        return this.http.get(Configuration.apiUrl + 'Api/Billing/PaymentMethod/ChangeDefault?id=' + id + '&isDefault=' + isDefault)
    }

    deletePaymentMethod(id): any {
        return this.http.get(Configuration.apiUrl + 'Api/Billing/PaymentMethod/Delete?id=' + id)
    }

    savePaymentMethodList(list): any {
        console.log(JSON.stringify(list))
        return this.http.post(Configuration.apiUrl + 'Api/billing/SavePaymentMethodList', JSON.stringify(list), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }   

    cancelPendingInvoice(payment): any {
        debugger
        console.log(JSON.stringify(payment))
        return this.http.post(Configuration.apiUrl + 'api/Billing/CancelPendingInvoice', JSON.stringify(payment), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    lookforScript(storeName): any {
        debugger
        return this.http.get(Configuration.apiUrl + 'Api/Profile/LookforScript?storeName=' + storeName)
    }

    adminCreateSubscription(storeName): any {
        return this.http.get(Configuration.apiUrl + 'Api/Profile/adminCreateSubscription?storeName=' + storeName)
    }

    adminChangeDomain(storeName, domain): any {
        debugger
        console.log('Api/Profile/AdminChangeDomain?storeName=' + storeName + '&newDomain=' + domain);
        return this.http.get(Configuration.apiUrl + 'Api/Profile/AdminChangeDomain?storeName=' + storeName + '&newDomain=' + domain)
    }

    getCustomizeAbTests(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Customize/AbTests');
    }

    getCustomizeCauseIcons(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Customize/GetCauseIcons');
    }

    getTransparency(): any {
        debugger
        return this.http.get(Configuration.apiUrl + 'Api/Customize/Transparency');
    }

    getContentToStore(seoUrl): any {
        return this.http.get(Configuration.apiUrl + 'Api/Contents/GetContentToStore?seoUrl=' + seoUrl)
    }

    updateCauseIcons(abTest): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/Customize/SaveCauseIcons', JSON.stringify(abTest), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updateAbTestCustomization(abTest): any {
        debugger
        console.log(JSON.stringify(abTest))
        return this.http.post(Configuration.apiUrl + 'Api/Customize/SaveAbTest', JSON.stringify(abTest), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updateTransparency(transparency): any {
        console.log(JSON.stringify(transparency));
        return this.http.post(Configuration.apiUrl + 'Api/Customize/SaveTransparency', JSON.stringify(transparency), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    goToJsFiddle(scriptHtml, title, description): any {
        debugger
        return this.http.post('https://jsfiddle.net/api/post', { html: scriptHtml, title, description }, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    deleteStore(storeId): any {
        return this.http.get(Configuration.apiUrl + 'Api/Account/DeleteAccountById?storeId=' + storeId, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    deleteImage(id): any {
        return this.http.get(Configuration.apiUrl + 'api/Customize/RemoveImage?id=' + id, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    getCampaignList(): any {
        return this.http.get(
          Configuration.apiUrl + "Api/Campaign/GetListByStoreUrl"
        );
    }
    //Área do ProductStore
    
    getProductStore(seoUrl : string): any {
        return this.http.get(Configuration.apiUrl + 'api/productStore/getBySeoUrl?seoUrl=' + seoUrl);
    }
    createProduct(product: Product, seoUrl:string) : any{
        return this.http.post(Configuration.apiUrl + 'api/productStore/addProduct?seoUrl=' + seoUrl, JSON.stringify(product) , {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
    editProduct(product: Product, seoUrl:string): any{
        return this.http.post(Configuration.apiUrl + 'api/productStore/editProduct?seoUrl=' + seoUrl, JSON.stringify(product) , {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
    deleteProduct(product: Product, seoUrl:string): any{
        console.log(product);
        return this.http.post(Configuration.apiUrl + 'api/productStore/deleteProduct?seoUrl=' + seoUrl, JSON.stringify(product) , {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
}